import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './components/Home';
import Privacy from './components/Privacy';
import Footer from './components/Footer';
import Cart from './components/Cart';
import ThankYou from './components/ThankYou';


function App() {
  return (
    <div className="App">
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path='privacy-policy' element={<Privacy />} />
      <Route path="register" element={<Cart />}/>
      <Route path="thank-you" element={<ThankYou />}/>
    </Routes>
    <Footer />
  </BrowserRouter>
    </div>
  );
}

export default App;
